import { render, staticRenderFns } from "./Oasis.vue?vue&type=template&id=606aec2b&scoped=true&"
import script from "./Oasis.vue?vue&type=script&lang=js&"
export * from "./Oasis.vue?vue&type=script&lang=js&"
import style0 from "./Oasis.vue?vue&type=style&index=0&id=606aec2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606aec2b",
  null
  
)

export default component.exports